import { createContext } from 'react'

export type AccessValue = {
  permissions: ReadonlySet<string>
}

export const AccessContext = createContext<AccessValue>({ permissions: new Set() })
